import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import React, { Fragment, useRef, useState } from "react";
import { deleteThisAndFollowEvents } from "../../../Calendar/calendarFunctions";
import { baseUrl } from "../../../assets/Animations";

export default function StudentDiscontinuationForm({
  event,
  abortCancellationFlow,
  setAllEvents,
  socket,
  setOpenEvent,
  setEditing,
}) {
  const [open, setOpen] = useState(true);
  const [reasonForCancellation, setReasonForCancellation] = React.useState("");

  const cancelButtonRef = useRef(null);

  const closeWhenDone = () => {
    abortCancellationFlow(false);
    setOpenEvent(false);
  };

  const rescheduleInstead = () => {
    setEditing(true);
    abortCancellationFlow(false);
  };

  const submitStudentDiscontinuationForm = async () => {
    await deleteThisAndFollowEvents(
      event,
      event.dateTime,
      setAllEvents,
      closeWhenDone,
      socket,
      event.teacherName
    );
    axios.post(`${baseUrl}/slack/${event.school}`, {
      message: `*${event.teacherName}* has discontinued lessons with *${
        event.studentName
      } ${
        event.familyName
      }*.\n\n*Reason for discontinuation:* ${reasonForCancellation}\n\n*Taking Effect:* ${new Date(
        event.dateTime
      ).toDateString()}\n\n*Family Email:* ${event.familyEmail} \n\n__________`,
    });
    //AUTO EMAIL TO ADMIN
    //AUTO EMAIL TO TEACHER
    //AUTO EMAIL TO STUDENT
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-30"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationTriangleIcon
                      className="h-6 w-6 text-red-600"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-base font-semibold leading-6 text-gray-900"
                    >
                      Discontinuation Form - {event.teacherName}
                    </Dialog.Title>
                    <div className="mb-5 text-left">
                      <label
                        htmlFor="student-name"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Student & Teacher
                      </label>
                      <p className="text-sm text-gray-500 inline-block my-1 mr-5 border-solid border border-gray-300 px-2 py-1 rounded-md">
                        {event.studentName} {event.familyName}
                      </p>
                      <p className="text-sm text-gray-500 inline-block my-1 mr-5 border-solid border border-gray-300 px-2 py-1 rounded-md">
                        {event.teacherName}
                      </p>
                    </div>
                    <div className="mt-2">
                      <label
                        htmlFor="reason-for-cancellation"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Reason for discontinuation
                      </label>
                      <div className="mt-2">
                        <textarea
                          id="reason-for-cancellation"
                          name="reason-for-cancellation"
                          rows={3}
                          className="block w-11/12 rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:py-1.5 sm:text-sm sm:leading-6"
                          defaultValue={""}
                          onChange={(e) =>
                            setReasonForCancellation(e.target.value)
                          }
                          value={reasonForCancellation}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    onClick={() => submitStudentDiscontinuationForm()}
                  >
                    Submit Cancellation
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => rescheduleInstead()}
                    ref={cancelButtonRef}
                  >
                    Reschedule Lesson
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
